let dev = true;
export const pre = (...args) => {
  if (dev) {
    args.length > 0
      ? console.log(
          "%c**LOGS**",
          "font-size:20;color:#fff;background-color:#dc5b4a; font-weight:900",

          { ...args }
        ) // logs 1+ comma separated arguments - ex: console.log(1, 'a', [])
      : console.log(""); // logs a blank line if no arguments.

    return args.length === 0
      ? undefined // returns undefined if no arguments passed.
      : args.length === 1
      ? args[0] // returns single argument's value if one argument.
      : args; // returns all args as an array if 2+ arguments.
  } else {
    return false;
  }
};
export const formatNum = (num) => {
  if (num === null || num === undefined || isNaN(Number(num))) {
    return "0";
  }
  return Number(num).toLocaleString();
};
